export default {
  dataIterator: {
    rowsPerPageText: 'Записей на странице:',
    rowsPerPageAll: 'Все',
    pageText: '{0}-{1} из {2}',
    noResultsText: 'Не найдено подходящих записей',
    nextPage: 'Следующая страница',
    prevPage: 'Предыдущая страница'
  },
  dataTable: {
    rowsPerPageText: 'Строк на странице:'
  },
  noDataText: 'Отсутствуют данные'
}
